import { GET, DELETE } from "../../../module/services/fetch";
import { map } from "rxjs/operators";
import { RESPONSE_TYPE } from "../../../module/constants";

export const fetchTabSections = () =>
  GET("module/sections").pipe(map((response: any) => response));

export const fetchAllAttachmentsInASection = (sectionId: string) =>
  GET(`module/sections/${sectionId}/attachments`).pipe(
    map((response: any) => response)
  );

export const fetchDeleteAttachment = (attachmentId: string) =>
  DELETE(`attachments/${attachmentId}`).pipe(map((response: any) => response));

export const fetchDownloadAttachment = (attachmentId: string) =>
  GET(
    `attachments/${attachmentId}`,
    undefined,
    undefined,
    RESPONSE_TYPE.BLOB
  ).pipe(map((response: any) => response));
